var site = window.site || {};
var generic;

site.account = site.account || {};

(function ($, Drupal) {
  Drupal.behaviors.giftCardBalanceLayoutV1 = {
    attach: function () {
      $(document).ready(function () {
        site.account.getDOMNodes();
        site.account.initGiftCards();
      });

      site.account.getDOMNodes = function () {
        site.account.giftCardForms = $('form#giftcard_balance');
      };

      site.account.initGiftCards = function () {
        var $giftcardBalanceError = $('.js-giftcard_balance_error');
        var bindform = function (giftform) {
          var $giftform = $(giftform);

          if (!$giftform) {
            return false;
          }
          $giftform.off('submit').on('submit', function (e) {
            e.preventDefault();
            var params = {
              '_SUBMIT': 'giftcard_balance',
              'GC_GIFTCARD_NUMBER': giftform.find('[name=GC_GIFTCARD_NUMBER]').val(),
              'GC_GIFTCARD_PIN': giftform.find('[name=GC_GIFTCARD_PIN]').val()
            };

            generic.jsonrpc.fetch({
              method: 'rpc.form',
              params: [params],
              onSuccess: function (jsonRpcResponse) {
                var data = jsonRpcResponse.getData();

                $giftform.find('.js-giftcard-balance-input-field').removeClass('error');
                $giftcardBalanceError.hide();
                $('.js-giftcard-balance-details').show();
                if (data.formatted_balance) {
                  $('.js-remaining-balance').html(data.formatted_balance);
                }
                if (data.expiration_date) {
                  $('.js-expiration-date').html(data.expiration_date);
                }
              },
              onFailure: function (jsonRpcResponse) {
                var errors = [];
                var errorMessage = jsonRpcResponse.getMessages();

                $('.js-giftcard-balance-details').hide();
                $giftcardBalanceError.show();
                $giftform.find('.js-giftcard-balance-input-field').addClass('error');

                errorMessage.forEach(function (message) {
                  errors.push({
                    key: message.key,
                    text: message.text
                  });
                });
                if (errors.length > 0) {
                  $giftcardBalanceError.removeClass('hidden');
                  $giftcardBalanceError.html(errors[0].text);
                }
              }
            });
          });
        };

        bindform(site.account.giftCardForms);
      };

      $('.js-togglePassword').on('click', function () {
        var passwordSelector = $('.js-giftcard-pin');
        var passwordType = (passwordSelector.attr('type') === 'password') ? 'text' : 'password';

        passwordSelector.prop('type', passwordType);
      });

      $('.js-giftcard-number-tooltip,.js-giftcard-pin-tooltip,.js-giftcard-terms-link').on('click', function (event) {
        event.preventDefault();
        var popup_id = $(this).data('id');
        var refContent = $('#' + popup_id).html();

        generic.overlay.launch({
          content: refContent,
          className: 'js-giftcard-balance-block-overlay',
          cssStyle: {
            width: '912px',
            height: '534px',
            top: 0,
            onLoad: function () {
              $('body, html').scrollTop(10);
            }
          }
        });
      });
      $(document).on('click', '.js-giftcard-accept_button', function () {
        $('#cboxClose', '.js-giftcard-balance-block-overlay').trigger('click');
      });
      $(document).on('click', '.js-giftcard-cancel_button', function (event) {
        event.preventDefault();
        var refContent = $('.js-giftcard-terms-info-popup').html();

        generic.overlay.launch({
          content: refContent,
          className: 'js-giftcard-balance-block-overlay',
          cssStyle: {
            width: '912px',
            height: '534px',
            top: 0,
            onLoad: function () {
              $('body, html').scrollTop(10);
            }
          }
        });
      });
    }
  };
})(jQuery, Drupal);
